import { httpBatchLink, createTRPCProxyClient, httpLink } from '@trpc/client';
import { createTRPCNext } from '@trpc/next';
import type { AppRouter } from '../server/routers/_appRouter';
import superjson from 'superjson';
import { createTRPCReact } from '@trpc/react-query';

// not needed since we don't SSR but keeping it around for when we upgrade to next ^13
const getBaseUrl = () => {
    if (typeof window !== 'undefined')
        // browser should use relative path
        return '';
    // assume localhost
    return `http://localhost:${process.env.PORT ?? 3000}`;
};

const getHttpLink = () => {
    return process.env.NEXT_PUBLIC_USE_MSW_BROWSER
        ? httpBatchLink({
              /**
               * If you want to use SSR, you need to use the server's full URL
               * @link https://trpc.io/docs/ssr
               **/
              url: `${getBaseUrl()}/api/trpc`,
              // You can pass any HTTP headers you wish here
              headers: async () => {
                  return {
                      // authorization: getAuthCookie(),
                  };
              },
          })
        : httpLink({
              /**
               * If you want to use SSR, you need to use the server's full URL
               * @link https://trpc.io/docs/ssr
               **/
              url: `${getBaseUrl()}/api/trpc`,
          });
};

export const trpcConfig = {
    transformer: superjson,
    links: [getHttpLink()],
};

export const trpcTestConfig = {
    transformer: superjson,
    links: [
        httpLink({
            /**
             * If you want to use SSR, you need to use the server's full URL
             * @link https://trpc.io/docs/ssr
             **/
            url: `/api/trpc`,
        }),
    ],
};

export const trpc = createTRPCNext<AppRouter>({
    config: () => {
        return trpcConfig;
    },
    /**
     * @link https://trpc.io/docs/ssr
     **/
    ssr: false,
});

export const tRPCProxyClient = createTRPCProxyClient<AppRouter>(trpcConfig);

export const trpcReact: ReturnType<typeof createTRPCReact<AppRouter>> = createTRPCReact<AppRouter>();
